import React, {useState, useEffect} from "react";
import styled from "styled-components";
import {Avatar, List, Image, Space, Tag, Pagination} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {getPopularInfo} from "../../http/home";
import {useStore} from "../../store";
import {transaction} from "mobx";
import {ScienceEntity} from "../../entity/science-entity";
import {BaseImageUrl} from "../../http/http";

const cover = require("../../image/public-cover.png");
const defaultIcon = require("../../image/default-pic.png")


const PublicityList: React.FC = () => {
    const [dataSource, setDataSource] = useState<ScienceEntity[]>([]);
    const {scienceStore} = useStore();
    useEffect(() => {
        getList();
        return;
    }, [])
    const getList = () => {
        const params = {
            pageNum: scienceStore.pagination.pageNum,
            pageSize: scienceStore.pagination.pageSize
        }
        getPopularInfo(params).then((res: any) => {
            if (res.data && res.data.list && res.data.list.length > 0) {
                let reg1 = /(<\/?p.*?>)/gi;
                res.data.list.map((element: any) => {
                    element.description = element.content ? element.content?.replace(reg1, '------').split('------------')[0].split('------')[1] : '';
                    return element;
                })
            }
            refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
            scienceStore.pagination.total = res.data ? res.data.total : 0
        }).catch((e) => {
            console.log("error:" + e.message)
        })
    }
    const refreshTableData = (data: ScienceEntity[]) => {
        const list: ScienceEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            scienceStore.setDataSource(list);
            setDataSource(list);
        })
    }
    const onSizeChange = (page: any, pageSize: any) => {
        scienceStore.pagination.pageSize = pageSize;
        scienceStore.pagination.pageNum = page;
        getList();
    }
    const toDetail = (record: any) => {
        window.open(`/home/publicity/detail?id=${record.id}`);
        // navigateTo('/home/publicity/detail', { state: { publicity: JSON.stringify(record) } });
    }

    const renderItem = (item: any) => {
        return <List.Item key={item.key}>
            <ItemWrapper>
                <Image preview={false} defaultValue={defaultIcon} style={{width:"200px", height: "200px", margin: "15px 40px 15px 15px"}}
                       src={item.cover ? BaseImageUrl+item.cover : cover}/>
                <CardWrapper>
                    <TitleSpan onClick={() => toDetail(item)}>{item.title}</TitleSpan>
                    <Space size={[0, 8]} wrap>
                        {
                            item.category ? item.category.split(',').map((category: string) => {
                                return <Tag color={"orange"} key={category}>{category}</Tag>
                            }) : ''
                        }
                    </Space>
                    <ContentSpan>
                        {item.description}
                    </ContentSpan>
                    <Space size={[0, 10]} style={{marginTop: "15px"}}>
                        {
                            item.userImg ? <Image width={24} style={{borderRadius: '50%'}}
                                                  src={BaseImageUrl + item.userImg}/> :
                                <Avatar shape="circle" size="small" icon={<UserOutlined/>}/>
                        }
                        <div style={{
                            cursor: "default",
                            color: "#1990ff",
                            margin: "0 15px"
                        }}>发布人员：{item.creater}</div>
                        <span>来源：{item.source}</span>
                        <span style={{margin: "0 15px"}}>发布时间：{item.createtime}</span>
                    </Space>
                </CardWrapper>
            </ItemWrapper>
        </List.Item>
    }

    return (<Wrapper>
        <List
            style={{overflow: "scroll", width: "70%", height: "100%", background: '#fff',  border: "1px solid #eeeeee",
                borderRadius: "5px"}}
            split={true}
            footer={<div/>}
            dataSource={dataSource}
            renderItem={renderItem}/>
        <Pagination
            size={"small"}
            style={{margin: "15px 15px 15px 0", alignSelf: "end"}}
            total={scienceStore.pagination.total}
            showQuickJumper={true}
            showSizeChanger={true}
            defaultPageSize={10}
            hideOnSinglePage={true}
            onChange={onSizeChange}
            current={scienceStore.pagination.pageNum}
        />
    </Wrapper>);
}

export default PublicityList;
const Wrapper = styled.div`
  & {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #DEDEDE;
    align-items: center;
    overflow: hidden;
    margin: auto;
    padding: 15px 0;
  }
`;

const CardWrapper = styled.div`
  & {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px;
  }
`;
const CardImg = styled.img`
  & {
    display: block;
    width: 200px;
    height: 150px;
    margin: 15px;
  }
`;

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    color: black;
    cursor: pointer;
  }
`;
const ContentSpan = styled.span`
  & {
    display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
    font-size: 14px;
    color: #333333;
    word-break: break-all;
    margin-top: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2; //行数
    -webkit-box-orient: vertical;
  }
`;
const ItemWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  display: flex;
  background-color: white;
  overflow: hidden;
`;
